let isDesktop = window.innerWidth >= 992;

window.addEventListener('resize', () => {
  isDesktop = window.innerWidth >= 992;
  window.dispatchEvent(new Event('fyle:resize'));
});

/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('careerSlider', () => ({
    slides: [],
    index: 0,
    slideSize: 0,
    slideMargin: 0,
    allowShift: true,
    posX1: 0,
    posX2: 0,
    posInitial: 0,
    posFinal: 0,

    get visibleCards() {
      return isDesktop ? 3 : 1;
    },

    init() {
      this.$nextTick(() => {
        const items = this.$refs.slides;
        this.slides = items.querySelectorAll('.item');
        if (!this.slides.length) {
          return;
        }

        this.calculateSlideDimensions();

        items.classList.add('loaded');
        items.style.left = `0px`;
        this.registerTouchEvents(items);

        window.addEventListener('fyle:resize', () => {
          this.calculateSlideDimensions();
          this.snapToCurrent();
        });
      });
    },

    calculateSlideDimensions() {
      this.slideSize = this.slides[0].offsetWidth;
      this.slideMargin = parseInt(getComputedStyle(this.slides[0]).marginRight) || 0;
    },

    registerTouchEvents(items) {
      items.addEventListener('touchstart', this.dragStart.bind(this));
      items.addEventListener('touchend', this.dragEnd.bind(this));
      items.addEventListener('touchmove', this.dragAction.bind(this));
    },

    dragStart(e) {
      this.posInitial = this.$refs.slides.offsetLeft;
      this.posX1 = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;

      // Disable transition during drag
      this.$refs.slides.classList.remove('is-animating');

      if (e.type !== 'touchstart') {
        document.onmouseup = this.dragEnd.bind(this);
        document.onmousemove = this.dragAction.bind(this);
      }
    },

    dragAction(e) {
      const currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      this.posX2 = this.posX1 - currentX;
      this.posX1 = currentX;
      this.$refs.slides.style.left = `${this.$refs.slides.offsetLeft - this.posX2}px`;
    },

    dragEnd() {
      this.posFinal = this.$refs.slides.offsetLeft;
      const moved = this.posFinal - this.posInitial;
      const threshold = this.slideSize / 4;

      if (moved < -threshold) {
        this.shiftSlide(1, 'drag');
      } else if (moved > threshold) {
        this.shiftSlide(-1, 'drag');
      } else {
        this.snapToCurrent();
      }

      document.onmouseup = null;
      document.onmousemove = null;
    },

    shiftSlide(dir, action) {
      if (!this.allowShift) {
        return;
      }

      const maxIndex = this.slides.length - this.visibleCards;

      if ((dir === 1 && this.index >= maxIndex) || (dir === -1 && this.index <= 0)) {
        this.snapToCurrent();
        return;
      }

      this.allowShift = false;

      // Enable transition
      this.$refs.slides.classList.add('is-animating');

      if (!action) {
        this.posInitial = this.$refs.slides.offsetLeft;
      }

      const move = dir === 1 ? -1 : 1;
      const newLeft = this.posInitial + (move * (this.slideSize + this.slideMargin));
      this.$refs.slides.style.left = `${newLeft}px`;

      this.index += dir;

      setTimeout(() => {
        this.allowShift = true;
        this.$refs.slides.classList.remove('is-animating');
      }, 100);
    },

    snapToCurrent() {
      this.$refs.slides.classList.add('is-animating');
      const offset = -(this.index * ((this.slideSize + this.slideMargin)));
      this.$refs.slides.style.left = `${offset}px`;

      setTimeout(() => {
        this.$refs.slides.classList.remove('is-animating');
      }, 100);
    }
  }));
});
